module.exports = __webpack_public_path__ + "img/references.bc0f1dc1.svg";